/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:51:55 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getListSubscriptionTierQuery = gql`
  query allSubscriptionTiers(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: SubscriptionTierFilter
  ) {
    items: allSubscriptionTiers(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
      monthlyPlan {
        cost {
          currencyCode
          amount
        }
      }
      annualPlan {
        cost {
          currencyCode
          amount
        }
      }
      isInitialTier
      isFreeTier
      # get these now to prevent missing key assignment errors in edit view
      capabilities {
        id
        description
        enabled
      }
      freeTrialDuration
      maximumEmployees
      maximumSubcontractors
      maximumProjects
      statistics {
        monthlySubscribers
        annualSubscribers
        freeSubscribers
      }
      isCustomTier
      customOrganisationsIds 
    }
    total: _allSubscriptionTiersMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
      __typename
    }
  }
`;
